import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import templates from './templates';

interface EmptyProps {
  templateId: string;
}

const Empty: React.FC<EmptyProps> = ({ templateId }) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const template = templates.find((t) => t.id === templateId);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      textAlign="center"
      p={3}
    >
      <Typography variant="h5" gutterBottom>
        {template ? template.title : 'Template'} Not Available Yet
      </Typography>
      <Typography variant="body1" paragraph>
        It looks like there&apos;s no transcript data to generate{' '}
        {template?.title || 'this template'} yet.
      </Typography>
      <Typography variant="body2" paragraph>
        We will notify you and refresh this page when available.
      </Typography>
      <Button onClick={handleOpenDialog} variant="outlined" color="secondary">
        Learn More about Templates
      </Button>
      <Dialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">What are Templates?</DialogTitle>
        <DialogContent>
          <Typography id="dialog-description">
            Templates are pre-defined formats for analyzing and summarizing your
            video transcripts. They help you quickly extract specific
            information from your videos, such as key points from meetings,
            action items from project discussions, or insights from customer
            interviews. To use templates, you first need to generate a
            transcript for your video.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Empty;
